import { useState } from "react";
import MonitorIcon from "@assets/svg/MonitorIcon";
import NotepadIcon from "@assets/svg/NotepadIcon";
import NotebookIcon from "@assets/svg/NotebookIcon";
import CheckSquareIcon from "@assets/svg/CheckSquareIcon";
import { Outlet, useSearchParams } from "react-router-dom";
import PlusCircleIcon from "@assets/svg/PlusCircleIcon";
import { NavLink } from "react-router-dom";

const stats = [
  {
    label: "Interviewing",
    value: 5,
    icon: <MonitorIcon />,
  },
  {
    label: "Viewed",
    value: 23,
    icon: <NotepadIcon />,
  },
  {
    label: "Submitted",
    value: 7,
    icon: <NotebookIcon />,
  },
  {
    label: "Applied",
    value: 12,
    icon: <CheckSquareIcon />,
  },
];

const tabs = [
  {
    label: "View by Job",
    route: "by-job",
  },
  {
    label: "View by Candidate",
    route: "by-candidate",
  },
  {
    label: "View by Hiring Company",
    route: "by-hiring-company",
  },
];

const JobPageLayout = () => {
  const [searchText, setSearchText] = useState('')

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow p-4 min-h-0">
      {/* Top container */}
      <div className="flex flex-col gap-7">
        <NavLink
          to={"/job/create"}
          className="w-max bg-primary rounded-md flex items-center justify-center text-white text-xs font-semibold py-2 px-3 hover:bg-black gap-1"
        >
          <PlusCircleIcon fill="white" />
          Create new job
        </NavLink>
        <div className="flex items-center gap-9 border-b pb-2 pl-3.5">
          {tabs?.map((tab) => {
            return (
              <NavLink
                key={tab?.route}
                to={tab?.route}
                className={({ isActive }) =>
                  `font-medium text-xs border-b-2 ${isActive
                    ? "text-primary border-primary"
                    : "text-light-grey border-transparent"
                  }`
                }
              >
                {tab?.label}
              </NavLink>
            );
          })}
        </div>
      </div>
      {/* List container */}
      <Outlet context={{
        searchText
      }} />
    </div>
  );
};

export default JobPageLayout;
